const AtomDatePicker = {
  parts: ["input", "value"],
  baseStyle: {
    value: {
      color: "gray.900",
    },
  },
};
export default AtomDatePicker;
